/**
 * @file
 * Initialize matchHeight Plugin
 *
 * This plugin is used to set an equal height of Elements which are
 * displayed side by side.
 */

(function ($, Drupal) {
  Drupal.behaviors.matchHeight = {
    attach: function attach(context) {
      let window_width_matchheight = $(window).width(),
        window_width_matchheight_event = window_width_matchheight;

      $('.mh-item').matchHeight();
      $('.tile__content').matchHeight();
      $('.tile__petition-context').matchHeight();
      $('.tile__politician').matchHeight();
      $('.tile__politician-detail').matchHeight();
      $('.tile-carousel .tile').matchHeight();

      // Set throttling for matchHeight
      $.fn.matchHeight._throttle = 500;
      $.fn.matchHeight._beforeUpdate = function(event, groups) {
        if (event.type === 'resize') {
          let new_window_width_matchheight = $(window).width();
          // if there was no change in width we remove the bindings so that
          // no height is calculated
          if (new_window_width_matchheight === window_width_matchheight) {
            $('.mh-item').matchHeight({ remove: true });
            $('.tile__content').matchHeight({ remove: true });
            $('.tile__petition-context').matchHeight({ remove: true });
            $('.tile__politician').matchHeight({ remove: true });
            $('.tile__politician-detail').matchHeight({ remove: true });
            $('.tile-carousel .tile').matchHeight({ remove: true });
            event.stopPropagation();
          }
        }
      }

      let setMatchHeight = debounce(function() {
        let new_window_width_matchheight_event = $(window).width();
        if (new_window_width_matchheight_event !== window_width_matchheight_event) {
          $('.mh-item').matchHeight();
          $('.tile__content').matchHeight();
          $('.tile__petition-context').matchHeight();
          $('.tile__politician').matchHeight();
          $('.tile__politician-detail').matchHeight();
          $('.tile-carousel .tile').matchHeight();
          window_width_matchheight_event = new_window_width_matchheight_event;
        }
      }, 250);
      $(window).on('resize', setMatchHeight);
    }
  };
})(jQuery, Drupal);
